
(function(){
  const menuOpen=document.querySelector('[data-mobile-menu-open]');
  const menuCloses=document.querySelectorAll('[data-mobile-menu-close]');
  function setMobileMenu(open){document.body.classList.toggle('mobile-menu-open',open)}
  if(menuOpen) menuOpen.addEventListener('click',()=>setMobileMenu(true));
  menuCloses.forEach(el=>el.addEventListener('click',()=>setMobileMenu(false)));
  document.querySelectorAll('.mobile-drawer-nav a').forEach(a=>a.addEventListener('click',()=>setMobileMenu(false)));
  document.addEventListener('keydown',e=>{if(e.key==='Escape')setMobileMenu(false)});

  const toggler=document.querySelector('[data-currency-toggle]');
  const wrap=document.querySelector('.currency-wrap');
  if(toggler&&wrap){
    toggler.addEventListener('click',e=>{e.stopPropagation();wrap.classList.toggle('open')});
    document.addEventListener('click',e=>{if(!wrap.contains(e.target))wrap.classList.remove('open')});
  }
  const countrySearch=document.querySelector('[data-country-search]');
  if(countrySearch){
    countrySearch.addEventListener('click',e=>e.stopPropagation());
    countrySearch.addEventListener('input',()=>{
      const q=countrySearch.value.trim().toLowerCase();
      document.querySelectorAll('.country-item').forEach(item=>{item.hidden=q&&!item.dataset.country.toLowerCase().includes(q)});
    });
  }
  document.querySelectorAll('.country-item').forEach(item=>item.addEventListener('click',()=>{if(wrap)wrap.classList.remove('open')}));

  function setLang(lang){
    document.documentElement.lang=lang;
    try{localStorage.setItem('momoLang',lang)}catch(e){}
    document.querySelectorAll('[data-en][data-fr]').forEach(el=>{el.innerHTML=el.getAttribute('data-'+lang)});
  }
  try{setLang(localStorage.getItem('momoLang')||'en')}catch(e){setLang('en')}

  document.querySelectorAll('[data-price-calculator]').forEach(calc=>{
    const base=parseFloat(calc.getAttribute('data-base')||'0');
    const extra=parseFloat(calc.getAttribute('data-extra')||'0');
    const qty=calc.querySelector('[data-extra-qty]');
    const total=calc.querySelector('[data-total]');
    if(!qty||!total)return;
    const update=()=>{const count=Math.max(0,parseInt(qty.value||'0',10)||0);qty.value=count;const value=base+count*extra;total.textContent='$'+value.toFixed(2)+' USD';total.dataset.totalValue=value.toFixed(2)};
    qty.addEventListener('input',update);qty.addEventListener('change',update);update();
  });

  document.querySelectorAll('[data-qty-stepper]').forEach(stepper=>{
    const input=stepper.querySelector('[data-product-qty]'); if(!input)return;
    const minus=stepper.querySelector('[data-qty-minus]'),plus=stepper.querySelector('[data-qty-plus]');
    const clamp=()=>{const min=parseInt(input.min||'1',10),max=parseInt(input.max||'99',10);let v=parseInt(input.value||String(min),10);if(!Number.isFinite(v))v=min;input.value=Math.max(min,Math.min(max,v));input.dispatchEvent(new Event('momoQtyChange',{bubbles:true}))};
    if(minus)minus.addEventListener('click',()=>{input.value=(parseInt(input.value||'1',10)||1)-1;clamp()});
    if(plus)plus.addEventListener('click',()=>{input.value=(parseInt(input.value||'1',10)||1)+1;clamp()});
    input.addEventListener('change',clamp);input.addEventListener('input',clamp);clamp();
  });

  document.querySelectorAll('[data-extra-stepper]').forEach(stepper=>{
    const input=stepper.querySelector('[data-extra-qty]'); if(!input)return;
    const minus=stepper.querySelector('[data-extra-minus]'),plus=stepper.querySelector('[data-extra-plus]');
    const clamp=()=>{const min=parseInt(input.min||'0',10),max=parseInt(input.max||'99',10);let v=parseInt(input.value||String(min),10);if(!Number.isFinite(v))v=min;input.value=Math.max(min,Math.min(max,v));input.dispatchEvent(new Event('momoExtraQtyChange',{bubbles:true}))};
    if(minus)minus.addEventListener('click',()=>{input.value=(parseInt(input.value||'0',10)||0)-1;clamp()});
    if(plus)plus.addEventListener('click',()=>{input.value=(parseInt(input.value||'0',10)||0)+1;clamp()});
    input.addEventListener('change',clamp);input.addEventListener('input',clamp);clamp();
  });

  document.querySelectorAll('[data-bundle-calculator]').forEach(calc=>{
    const baseQtyEl=calc.querySelector('[data-base-qty]');
    const extraCnQtyEl=calc.querySelector('[data-extra-cn-qty]');
    const extraJpQtyEl=calc.querySelector('[data-extra-jp-qty]');
    const totalEl=calc.querySelector('[data-total]');
    const paymentWrap=calc.querySelector('[data-dynamic-payment-wrap]');
    const paymentNote=calc.querySelector('[data-bundle-payment-note]');
    const update=()=>{
      const baseCents=parseInt(calc.dataset.baseCents||'0',10)||0;
      const extraCnCents=parseInt(calc.dataset.extraCnCents||'0',10)||0;
      const extraJpCents=parseInt(calc.dataset.extraJpCents||'0',10)||0;
      const baseQty=Math.max(1,parseInt(baseQtyEl&&baseQtyEl.value||'1',10)||1);
      const extraCnQty=Math.max(0,parseInt(extraCnQtyEl&&extraCnQtyEl.value||'0',10)||0);
      const extraJpQty=Math.max(0,parseInt(extraJpQtyEl&&extraJpQtyEl.value||'0',10)||0);
      const totalCents=baseQty*(baseCents+(extraCnQty*extraCnCents)+(extraJpQty*extraJpCents));
      const hasExtras=extraCnQty>0||extraJpQty>0;
      const baseAvailable=calc.dataset.baseAvailable!=='false';
      const cnAvailable=calc.dataset.extraCnAvailable!=='false';
      const jpAvailable=calc.dataset.extraJpAvailable!=='false';
      const canAdd=baseAvailable&&(!extraCnQty||cnAvailable)&&(!extraJpQty||jpAvailable);
      if(totalEl)totalEl.textContent='$'+(totalCents/100).toFixed(2)+' USD';
      if(paymentWrap)paymentWrap.hidden=hasExtras||!baseAvailable;
      if(paymentNote)paymentNote.hidden=!hasExtras;
      const addBtn=calc.querySelector('[data-momo-bundle-add]');
      if(addBtn){
        addBtn.dataset.liveAvailable=canAdd?'true':'false';
        addBtn.disabled=!canAdd;
        addBtn.classList.toggle('momo-disabled',!canAdd);
        addBtn.textContent=canAdd?'Add to cart':'Sold out';
      }
    };
    ['input','change','momoQtyChange','momoExtraQtyChange'].forEach(evt=>calc.addEventListener(evt,update));
    update();
  });

  async function refreshCartCount(){
    try{const cart=await fetch(window.momoRoutes.cart+'.js').then(r=>r.json());document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count)}catch(e){}
  }
  async function addItems(items,feedback,button){
    if(!items.length)return;
    if(button)button.disabled=true;
    try{
      const r=await fetch(window.momoRoutes.cartAdd+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      let responseData=null;
      try{responseData=await r.json()}catch(_e){}
      if(!r.ok){
        const message=(responseData&&(responseData.description||responseData.message))||'Could not add this item.';
        throw new Error(message);
      }
      await refreshCartCount();
      if(feedback)feedback.textContent='Added to cart ✓';
      if(window.MomoLiveInventory&&window.MomoLiveInventory.refresh){window.MomoLiveInventory.refresh(true)}
    }catch(e){if(feedback)feedback.textContent=(e&&e.message)||'Could not add this item.'}
    finally{if(button)button.disabled=(button.dataset.liveAvailable==='false');setTimeout(()=>{if(feedback)feedback.textContent=''},2500)}
  }

  document.querySelectorAll('[data-momo-variant-add]').forEach(btn=>btn.addEventListener('click',()=>{
    const panel=btn.closest('[data-purchase-panel]')||btn.parentElement;
    const qtyEl=panel.querySelector('[data-product-qty]');
    const qty=Math.max(1,parseInt(qtyEl&&qtyEl.value||'1',10)||1);
    const id=parseInt(btn.dataset.variantId||'0',10);
    const feedback=panel.querySelector('[data-cart-feedback]');
    if(id)addItems([{id,quantity:qty}],feedback,btn);
  }));

  document.querySelectorAll('[data-momo-bundle-add]').forEach(btn=>btn.addEventListener('click',()=>{
    const calc=btn.closest('[data-bundle-calculator]')||btn.closest('.detail-copy')||document;
    const baseQtyEl=calc.querySelector('[data-base-qty]')||calc.querySelector('[data-product-qty]');
    const extraCnEl=calc.querySelector('[data-extra-cn-qty]');
    const extraJpEl=calc.querySelector('[data-extra-jp-qty]');
    const baseQty=Math.max(1,parseInt(baseQtyEl&&baseQtyEl.value||'1',10)||1);
    const extraCnQty=Math.max(0,parseInt(extraCnEl&&extraCnEl.value||'0',10)||0);
    const extraJpQty=Math.max(0,parseInt(extraJpEl&&extraJpEl.value||'0',10)||0);
    const baseId=parseInt(btn.dataset.baseVariant||'0',10);
    const extraCnId=parseInt(btn.dataset.extraCnVariant||'0',10);
    const extraJpId=parseInt(btn.dataset.extraJpVariant||'0',10);
    const feedback=calc.querySelector('[data-cart-feedback]');
    if(!baseId){if(feedback)feedback.textContent='Product setup required.';return;}
    if(extraCnQty>0&&!extraCnId){if(feedback)feedback.textContent='Chinese extra pack setup required.';return;}
    if(extraJpQty>0&&!extraJpId){if(feedback)feedback.textContent='Japanese extra pack setup required.';return;}
    const items=[{id:baseId,quantity:baseQty}];
    if(extraCnId&&extraCnQty)items.push({id:extraCnId,quantity:extraCnQty*baseQty});
    if(extraJpId&&extraJpQty)items.push({id:extraJpId,quantity:extraJpQty*baseQty});
    addItems(items,feedback,btn);
  }));

  document.querySelectorAll('.momo-product-form').forEach(form=>form.addEventListener('submit',async e=>{
    if(!window.fetch)return; e.preventDefault();
    const id=parseInt((form.querySelector('[name="id"]')||{}).value||'0',10);
    const q=parseInt((form.querySelector('[name="quantity"]')||{}).value||'1',10)||1;
    const btn=form.querySelector('[data-add-button]'), feedback=form.querySelector('[data-cart-feedback]');
    if(id)addItems([{id,quantity:q}],feedback,btn);
  }));

  document.querySelectorAll('[data-share-product]').forEach(btn=>btn.addEventListener('click',async()=>{
    const title=btn.getAttribute('data-share-title')||document.title,url=location.href;
    try{if(navigator.share){await navigator.share({title,url});return}if(navigator.clipboard)await navigator.clipboard.writeText(url);btn.classList.add('share-success');setTimeout(()=>btn.classList.remove('share-success'),2200)}catch(e){}
  }));
})();

/* Cart quantity stepper */
document.addEventListener('click',function(e){
  const btn=e.target.closest('[data-cart-minus],[data-cart-plus]');
  if(!btn)return;
  const stepper=btn.closest('[data-cart-stepper]');
  const input=stepper&&stepper.querySelector('[data-cart-qty-input]');
  const form=btn.closest('form');
  if(!input||!form)return;
  const current=parseInt(input.value||'0',10)||0;
  input.value=Math.max(0,current+(btn.hasAttribute('data-cart-plus')?1:-1));
  if(form.requestSubmit) form.requestSubmit(); else form.submit();
});
document.addEventListener('change',function(e){
  if(!e.target.matches('[data-cart-qty-input]'))return;
  const form=e.target.closest('form');
  if(form){ if(form.requestSubmit) form.requestSubmit(); else form.submit(); }
});


/* Live Shopify inventory + price sync: keeps product pages and product cards current without theme edits. */
(function(){
  const cfg=window.momoLiveShop||{};
  const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||((window.momoRoutes&&window.momoRoutes.root)||'/');
  const interval=Math.max(15000,parseInt(cfg.interval||30000,10)||30000);
  const cache=new Map();
  let running=false;

  function money(cents){
    const currency=cfg.currency||'USD';
    const locale=(document.documentElement.lang||'en').replace('_','-');
    const value=(Number(cents)||0)/100;
    if(currency==='USD')return '$'+value.toFixed(2)+' USD';
    try{return new Intl.NumberFormat(locale,{style:'currency',currency,currencyDisplay:'symbol'}).format(value)+' '+currency}
    catch(e){return value.toFixed(2)+' '+currency}
  }
  function urlFor(handle){
    const clean=String(handle||'').trim();
    if(!clean)return '';
    const base=root.endsWith('/')?root:root+'/';
    return base+'products/'+encodeURIComponent(clean)+'.js?momo_live='+Date.now();
  }
  async function getProduct(handle,force){
    handle=String(handle||'').trim(); if(!handle)return null;
    const cached=cache.get(handle);
    if(!force&&cached&&Date.now()-cached.time<5000)return cached.data;
    try{
      const r=await fetch(urlFor(handle),{credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}});
      if(!r.ok)throw new Error('Product sync failed');
      const data=await r.json();
      cache.set(handle,{time:Date.now(),data});
      return data;
    }catch(e){return cached?cached.data:null}
  }
  function variantById(product,id){
    id=String(id||'');
    return product&&Array.isArray(product.variants)?product.variants.find(v=>String(v.id)===id):null;
  }
  function firstPurchasable(product){
    if(!product||!Array.isArray(product.variants))return null;
    return product.variants.find(v=>v.available)||product.variants[0]||null;
  }
  function productAvailable(product){
    if(!product)return false;
    if(typeof product.available==='boolean')return product.available;
    return !!(product.variants||[]).find(v=>v.available);
  }
  function setStock(el,available){
    if(!el)return;
    el.classList.toggle('in-stock',!!available);
    el.classList.toggle('sold-out',!available);
    const text=el.querySelector('span:last-child')||el;
    text.textContent=available?'In stock':'Sold out';
  }
  function setButton(btn,available){
    if(!btn)return;
    btn.dataset.liveAvailable=available?'true':'false';
    btn.disabled=!available;
    btn.classList.toggle('momo-disabled',!available);
    if(btn.matches('[data-live-add-button]'))btn.textContent=available?'Add to cart':'Sold out';
  }
  function updateQtyMax(input,variant){
    if(!input||!variant)return;
    const qty=Number(variant.inventory_quantity);
    const tracked=variant.inventory_management!=null;
    const deny=variant.inventory_policy==='deny';
    if(Number.isFinite(qty)&&tracked&&deny){
      input.max=String(Math.max(1,qty));
      if(Number(input.value)>qty&&qty>0)input.value=String(qty);
    }
  }
  function setVariantPrice(el,variant){
    if(!el||!variant)return;
    const formatted=money(variant.price);
    if(el.classList.contains('price-line')){
      const small=el.querySelector('small');
      el.innerHTML=formatted+(small?' '+small.outerHTML:'');
    }else if(el.classList.contains('blind-addon-price')||el.closest('.extra-pack-quick-head')){
      el.textContent=formatted+' / pack';
    }else{
      el.textContent=formatted;
    }
  }
  function ensureCardStock(card,available){
    let el=card.querySelector('[data-live-card-stock]');
    if(!el){
      el=document.createElement('div');
      el.className='card-stock-status';
      el.setAttribute('data-live-card-stock','');
      el.innerHTML='<span class="stock-dot" aria-hidden="true"></span><span></span>';
      const anchor=card.querySelector('[data-live-card-price], .price, .price-stack');
      if(anchor)anchor.insertAdjacentElement('afterend',el); else card.appendChild(el);
    }
    setStock(el,available);
    card.classList.toggle('is-sold-out',!available);
  }
  async function syncCard(card,force){
    const handle=card.dataset.liveProductHandle; if(!handle)return;
    const product=await getProduct(handle,force); if(!product)return;
    const price=card.querySelector('[data-live-card-price]');
    if(price&&Number.isFinite(Number(product.price)))price.textContent=money(product.price);
    ensureCardStock(card,productAvailable(product));
  }
  async function syncProductRoot(node,force){
    const mainHandle=node.dataset.liveProductHandle||'';
    const handles=new Set(); if(mainHandle)handles.add(mainHandle);
    node.querySelectorAll('[data-live-variant-handle]').forEach(el=>{if(el.dataset.liveVariantHandle)handles.add(el.dataset.liveVariantHandle)});
    const products={};
    await Promise.all([...handles].map(async h=>{products[h]=await getProduct(h,force)}));
    const main=products[mainHandle]||null;
    if(main){
      const select=node.querySelector('[data-live-variant-select]');
      let selectedId=select&&select.value;
      if(!selectedId){
        const hidden=node.querySelector('.momo-product-form input[name="id"]');
        selectedId=hidden&&hidden.value;
      }
      let selected=variantById(main,selectedId)||firstPurchasable(main);
      if(selected){
        const mainPrice=node.querySelector('[data-live-main-price]'); if(mainPrice)mainPrice.textContent=money(selected.price);
        node.querySelectorAll('[data-live-stock]:not([data-live-variant-handle])').forEach(el=>{
          const id=el.dataset.liveVariantId;
          const v=variantById(main,id)||selected; setStock(el,!!v.available);
        });
        node.querySelectorAll('[data-live-add-button]:not([data-live-variant-handle])').forEach(btn=>{
          if(btn.hasAttribute('data-base-variant')){
            btn.dataset.baseVariant=String(selected.id);
          }
          btn.dataset.liveVariantId=String(selected.id);
          setButton(btn,!!selected.available);
        });
        node.querySelectorAll('[data-live-qty]:not([data-live-variant-handle])').forEach(input=>{
          input.dataset.liveVariantId=String(selected.id); updateQtyMax(input,selected);
        });
        node.querySelectorAll('[data-live-payment-wrap]').forEach(el=>{el.hidden=!selected.available});
        const calc=node.querySelector('[data-bundle-calculator]');
        if(calc){calc.dataset.baseCents=String(selected.price);calc.dataset.baseAvailable=selected.available?'true':'false';calc.dispatchEvent(new Event('momoQtyChange',{bubbles:true}))}
      }
      if(select){
        [...select.options].forEach(opt=>{
          const v=variantById(main,opt.value); if(v){opt.disabled=!v.available}
        });
      }
    }
    node.querySelectorAll('[data-live-variant-id][data-live-variant-handle]').forEach(el=>{
      const handle=el.dataset.liveVariantHandle, product=products[handle];
      const variant=variantById(product,el.dataset.liveVariantId); if(!variant)return;
      if(el.hasAttribute('data-live-variant-price'))setVariantPrice(el,variant);
      if(el.hasAttribute('data-live-stock'))setStock(el,!!variant.available);
      if(el.hasAttribute('data-live-add-button'))setButton(el,!!variant.available);
      if(el.matches('input'))updateQtyMax(el,variant);
      const calc=el.closest('[data-bundle-calculator]');
      if(calc&&el.hasAttribute('data-live-variant-price')){
        const txt=(el.closest('.blind-addon-card')?.textContent||'').toLowerCase();
        if(txt.includes('chinese')){calc.dataset.extraCnCents=String(variant.price);calc.dataset.extraCnAvailable=variant.available?'true':'false'}
        if(txt.includes('japanese')){calc.dataset.extraJpCents=String(variant.price);calc.dataset.extraJpAvailable=variant.available?'true':'false'}
        calc.dispatchEvent(new Event('momoExtraQtyChange',{bubbles:true}));
      }
    });
    node.setAttribute('data-live-synced-at',String(Date.now()));
  }
  async function refresh(force){
    if(running||document.hidden)return;
    running=true;
    try{
      const roots=[...document.querySelectorAll('[data-live-inventory-root]')];
      const cards=[...document.querySelectorAll('[data-live-card][data-live-product-handle]')];
      await Promise.all([...roots.map(el=>syncProductRoot(el,force)),...cards.map(el=>syncCard(el,force))]);
    }finally{running=false}
  }

  document.addEventListener('change',e=>{
    const select=e.target.closest&&e.target.closest('[data-live-variant-select]');
    if(!select)return;
    const rootEl=select.closest('[data-live-inventory-root]');
    if(rootEl)syncProductRoot(rootEl,true);
  });
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)refresh(true)});
  window.addEventListener('focus',()=>refresh(true));
  window.addEventListener('online',()=>refresh(true));
  window.MomoLiveInventory={refresh,getProduct};
  refresh(true);
  setInterval(()=>refresh(true),interval);
})();

/* Extra Packs auto-binding + live inventory sync.
   Supports either one "Extra Packs" product with Chinese/Japanese variants,
   or two separate Chinese/Japanese add-on products. */
(function(){
  const selector='[data-extra-pack-key]';
  if(!document.querySelector(selector))return;
  const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||((window.momoRoutes&&window.momoRoutes.root)||'/');
  const state={cn:null,jp:null,last:0,running:false};
  const interval=20000;

  function norm(v){return String(v||'').toLowerCase().replace(/[–—_]/g,'-').replace(/[^a-z0-9]+/g,' ').trim()}
  function handleFromProduct(p){
    if(p&&p.handle)return p.handle;
    const url=p&&p.url||'';
    const m=String(url).match(/\/products\/([^/?#]+)/i);
    return m?decodeURIComponent(m[1]):'';
  }
  async function productByHandle(handle,force){
    if(!handle)return null;
    if(window.MomoLiveInventory&&window.MomoLiveInventory.getProduct){
      return window.MomoLiveInventory.getProduct(handle,!!force);
    }
    try{
      const base=root.endsWith('/')?root:root+'/';
      const r=await fetch(base+'products/'+encodeURIComponent(handle)+'.js?momo_extra='+Date.now(),{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      return r.ok?await r.json():null;
    }catch(e){return null}
  }
  function isWrongProduct(text){
    return text.includes('blind scoop')||text.includes('booster box')||text.includes('gift box')||text.includes('giftbox')||text.includes('dream illustrating');
  }
  function langWords(lang){return lang==='cn'?['simplified chinese','chinese',' cn ',' cn','cn ']:['japanese',' jp ',' jp','jp ']}
  function languageMatch(text,lang){
    text=' '+norm(text)+' ';
    return langWords(lang).some(x=>text.includes(x));
  }
  function chooseVariant(product,lang){
    if(!product||!Array.isArray(product.variants)||!product.variants.length)return null;
    const ptext=norm((product.title||'')+' '+(product.handle||''));
    let best=null,bestScore=-999;
    product.variants.forEach(v=>{
      const vt=norm(v.title||'');
      const text=ptext+' '+vt;
      let score=0;
      if(languageMatch(vt,lang))score+=20;
      if(languageMatch(ptext,lang))score+=12;
      if(text.includes('extra'))score+=10;
      if(text.includes('add on')||text.includes('addon'))score+=7;
      if(text.includes('pack'))score+=4;
      if(v.available)score+=1;
      if(isWrongProduct(text))score-=40;
      if(score>bestScore){bestScore=score;best=v}
    });
    if(bestScore<8)return null;
    return best;
  }
  function productScore(product,lang){
    if(!product)return -999;
    const text=norm((product.title||'')+' '+(product.handle||''));
    if(isWrongProduct(text))return -999;
    let score=0;
    if(languageMatch(text,lang))score+=14;
    if(text.includes('extra'))score+=12;
    if(text.includes('add on')||text.includes('addon'))score+=8;
    if(text.includes('pack'))score+=5;
    if(text==='extra packs'||text==='extra pack')score+=15;
    const v=chooseVariant(product,lang);
    if(v)score+=15;
    return score;
  }
  async function tryHandles(lang){
    const handles=lang==='cn'?
      ['extra-packs-cn','extra-pack-cn','simplified-chinese-extra-pack','simplified-chinese-extra-packs','chinese-extra-pack','chinese-extra-packs','extra-pack-chinese','extra-packs-chinese','extra-packs','extra-pack','blind-scoop-extra-packs','pokemon-extra-packs']:
      ['extra-packs-jp','extra-pack-jp','japanese-extra-pack','japanese-extra-packs','extra-pack-japanese','extra-packs-japanese','extra-packs','extra-pack','blind-scoop-extra-packs','pokemon-extra-packs'];
    for(const h of handles){
      const p=await productByHandle(h,true);
      const v=chooseVariant(p,lang);
      if(v&&productScore(p,lang)>=8)return {product:p,variant:v,handle:h};
    }
    return null;
  }
  async function predictiveProducts(q){
    try{
      const base=root.endsWith('/')?root:root+'/';
      const url=base+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show';
      const r=await fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if(!r.ok)return [];
      const d=await r.json();
      return (((d||{}).resources||{}).results||{}).products||[];
    }catch(e){return []}
  }
  async function catalogProducts(){
    const base=root.endsWith('/')?root:root+'/';
    for(const path of ['products.json?limit=250','collections/all/products.json?limit=250']){
      try{
        const r=await fetch(base+path,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
        if(!r.ok)continue;
        const d=await r.json();
        if(Array.isArray(d.products)&&d.products.length)return d.products;
      }catch(e){}
    }
    return [];
  }
  async function hydrateCandidate(raw){
    const handle=handleFromProduct(raw);
    if(!handle)return null;
    const p=await productByHandle(handle,true);
    return p?{product:p,handle}:null;
  }
  async function discover(lang){
    // First reuse any server-rendered handle already attached to this language.
    const existing=document.querySelector('[data-extra-pack-key="'+lang+'"][data-live-variant-handle]');
    if(existing){
      const h=existing.dataset.liveVariantHandle;
      const p=await productByHandle(h,true);
      const v=(p&&p.variants||[]).find(x=>String(x.id)===String(existing.dataset.liveVariantId||existing.dataset.variantId||''))||chooseVariant(p,lang);
      if(v&&productScore(p,lang)>=8&&!isWrongProduct(norm((p&&p.title||'')+' '+(p&&p.handle||''))))return {product:p,variant:v,handle:h};
    }
    const direct=await tryHandles(lang); if(direct)return direct;

    const queries=lang==='cn'?['extra packs cn','simplified chinese extra pack','chinese extra pack','extra packs']:['extra packs jp','japanese extra pack','extra packs'];
    let raws=[];
    for(const q of queries){raws=raws.concat(await predictiveProducts(q))}
    const seen=new Set();
    let best=null,bestScore=-999;
    for(const raw of raws){
      const h=handleFromProduct(raw); if(!h||seen.has(h))continue; seen.add(h);
      const full=await hydrateCandidate(raw); if(!full)continue;
      const v=chooseVariant(full.product,lang); if(!v)continue;
      const score=productScore(full.product,lang);
      if(score>bestScore){bestScore=score;best={product:full.product,variant:v,handle:full.handle}}
    }
    if(best&&bestScore>=8)return best;

    const catalog=await catalogProducts();
    for(const raw of catalog){
      const h=handleFromProduct(raw); if(!h||seen.has(h))continue; seen.add(h);
      const full=(raw.variants&&raw.handle)?{product:raw,handle:h}:await hydrateCandidate(raw); if(!full)continue;
      const v=chooseVariant(full.product,lang); if(!v)continue;
      const score=productScore(full.product,lang);
      if(score>bestScore){bestScore=score;best={product:full.product,variant:v,handle:full.handle}}
    }
    return bestScore>=8?best:null;
  }
  function money(cents){
    const currency=(window.momoLiveShop&&window.momoLiveShop.currency)||'USD';
    const n=(Number(cents)||0)/100;
    return currency==='USD'?'$'+n.toFixed(2)+' USD':n.toFixed(2)+' '+currency;
  }
  function setPrice(el,v){
    if(!el||!v)return;
    if(el.classList.contains('price-line')){
      const small=el.querySelector('small');
      el.innerHTML=money(v.price)+(small?' '+small.outerHTML:'');
    }else if(el.classList.contains('blind-addon-price')||el.closest('.extra-pack-quick-head')){
      el.textContent=money(v.price)+' / pack';
    }
  }
  function setStock(el,v){
    if(!el||!v)return;
    el.classList.toggle('in-stock',!!v.available);
    el.classList.toggle('sold-out',!v.available);
    let text=el.querySelector('span:last-child');
    if(text)text.textContent=v.available?'In stock':'Sold out';
  }
  function setQty(input,v){
    if(!input||!v)return;
    input.dataset.liveVariantId=String(v.id);
    const qty=Number(v.inventory_quantity);
    const tracked=v.inventory_management!=null;
    const deny=v.inventory_policy==='deny';
    input.max=(Number.isFinite(qty)&&tracked&&deny)?String(Math.max(0,qty)):'99';
    if(Number(input.value)>Number(input.max))input.value=input.max;
  }
  function apply(lang,found){
    if(!found||!found.variant)return;
    const v=found.variant,h=found.handle;
    document.querySelectorAll('[data-extra-pack-key="'+lang+'"]').forEach(el=>{
      el.dataset.liveVariantId=String(v.id);
      el.dataset.liveVariantHandle=h;
      if(el.hasAttribute('data-live-variant-price')||el.classList.contains('price-line')||el.classList.contains('blind-addon-price')||el.closest('.extra-pack-quick-head')){
        el.setAttribute('data-live-variant-price',String(v.id)); setPrice(el,v);
      }
      if(el.matches('input'))setQty(el,v);
      if(el.classList.contains('stock-status')){el.setAttribute('data-live-stock','');setStock(el,v)}
      if(el.matches('button[data-momo-variant-add]')){
        el.dataset.variantId=String(v.id);
        el.setAttribute('data-live-add-button','');
        el.disabled=!v.available;
        el.classList.toggle('momo-disabled',!v.available);
        el.textContent=v.available?'Add to cart':'Sold out';
        el.dataset.liveAvailable=v.available?'true':'false';
      }
    });
    document.querySelectorAll('[data-bundle-calculator]').forEach(calc=>{
      if(lang==='cn'){
        calc.dataset.extraCnCents=String(v.price);calc.dataset.extraCnAvailable=v.available?'true':'false';
        const btn=calc.querySelector('[data-momo-bundle-add]');if(btn)btn.dataset.extraCnVariant=String(v.id);
      }else{
        calc.dataset.extraJpCents=String(v.price);calc.dataset.extraJpAvailable=v.available?'true':'false';
        const btn=calc.querySelector('[data-momo-bundle-add]');if(btn)btn.dataset.extraJpVariant=String(v.id);
      }
      calc.dispatchEvent(new Event('momoExtraQtyChange',{bubbles:true}));
    });
  }
  async function sync(force){
    if(state.running||document.hidden)return;
    if(!force&&Date.now()-state.last<5000)return;
    state.running=true;
    try{
      const [cn,jp]=await Promise.all([discover('cn'),discover('jp')]);
      if(cn){state.cn=cn;apply('cn',cn)}
      if(jp){state.jp=jp;apply('jp',jp)}
      state.last=Date.now();
      if(window.MomoLiveInventory&&window.MomoLiveInventory.refresh)window.MomoLiveInventory.refresh(true);
    }finally{state.running=false}
  }
  sync(true);
  setInterval(()=>sync(true),interval);
  window.addEventListener('focus',()=>sync(true));
  window.addEventListener('online',()=>sync(true));
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)sync(true)});
  window.MomoExtraPackSync={refresh:()=>sync(true)};
})();

/* Momo storefront resilience + security hardening layer.
   Keeps Shopify as the source of truth for price/availability and makes stale
   handles recoverable without changing the visual design. */
(function(){
  'use strict';
  const cfg=window.momoLiveShop||{};
  const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||((window.momoRoutes&&window.momoRoutes.root)||'/');
  const timeout=Math.max(3000,Math.min(15000,Number(cfg.requestTimeout)||8000));
  const productCache=new Map();
  const resolveCache=new Map();

  function sameOriginUrl(path){
    try{return new URL(path,location.origin).origin===location.origin}catch(e){return false}
  }
  async function safeFetch(url,options){
    if(!sameOriginUrl(url))throw new Error('Blocked cross-origin storefront request');
    const controller=('AbortController' in window)?new AbortController():null;
    const timer=controller?setTimeout(()=>controller.abort(),timeout):null;
    try{
      return await fetch(url,Object.assign({
        credentials:'same-origin',
        cache:'no-store',
        headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}
      },options||{},controller?{signal:controller.signal}:{}));
    }finally{if(timer)clearTimeout(timer)}
  }
  function normalize(s){return String(s||'').toLowerCase().replace(/[–—_]/g,' ').replace(/[^a-z0-9]+/g,' ').trim()}
  function handleFromUrl(url){const m=String(url||'').match(/\/products\/([^/?#]+)/i);return m?decodeURIComponent(m[1]):''}
  function scoreCandidate(candidate,query){
    const q=normalize(query),t=normalize((candidate.title||'')+' '+(candidate.handle||'')+' '+(candidate.url||''));
    if(!q||!t)return 0;
    const words=q.split(' ').filter(w=>w.length>2);
    let score=0; for(const w of words){if(t.includes(w))score+=1}
    if(t.includes(q))score+=10;
    return score;
  }
  async function fetchProduct(handle){
    handle=String(handle||'').trim(); if(!handle)return null;
    const hit=productCache.get(handle); if(hit&&Date.now()-hit.time<10000)return hit.data;
    try{
      const base=root.endsWith('/')?root:root+'/';
      const r=await safeFetch(base+'products/'+encodeURIComponent(handle)+'.js?momo_secure='+Date.now());
      if(!r.ok)return null;
      const data=await r.json(); productCache.set(handle,{time:Date.now(),data}); return data;
    }catch(e){return null}
  }
  async function resolveProduct(query){
    query=String(query||'').trim(); if(!query)return null;
    const key=normalize(query); const cached=resolveCache.get(key);
    if(cached&&Date.now()-cached.time<60000)return cached.data;
    try{
      const base=root.endsWith('/')?root:root+'/';
      const r=await safeFetch(base+'search/suggest.json?q='+encodeURIComponent(query)+'&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show');
      if(!r.ok)return null;
      const d=await r.json();
      const list=((((d||{}).resources||{}).results||{}).products)||[];
      let best=null,bestScore=-1;
      for(const c of list){const sc=scoreCandidate(c,query);if(sc>bestScore){best=c;bestScore=sc}}
      if(!best)return null;
      const handle=best.handle||handleFromUrl(best.url); if(!handle)return null;
      const product=await fetchProduct(handle); if(!product)return null;
      const data={handle,product}; resolveCache.set(key,{time:Date.now(),data}); return data;
    }catch(e){return null}
  }
  function money(cents){
    const currency=cfg.currency||'USD',value=(Number(cents)||0)/100,locale=(document.documentElement.lang||'en').replace('_','-');
    if(currency==='USD')return '$'+value.toFixed(2)+' USD';
    try{return new Intl.NumberFormat(locale,{style:'currency',currency,currencyDisplay:'symbol'}).format(value)+' '+currency}catch(e){return value.toFixed(2)+' '+currency}
  }
  function applyCard(card,p){
    if(!card||!p)return;
    const price=card.querySelector('[data-live-card-price]'); if(price&&Number.isFinite(Number(p.price)))price.textContent=money(p.price);
    const available=typeof p.available==='boolean'?p.available:!!(p.variants||[]).find(v=>v.available);
    card.classList.toggle('is-sold-out',!available);
    const btn=card.querySelector('.btn'); if(btn){btn.setAttribute('aria-disabled',available?'false':'true');btn.classList.toggle('momo-disabled',!available)}
  }
  async function healCards(){
    const cards=[...document.querySelectorAll('[data-live-card]')];
    for(const card of cards){
      let handle=card.dataset.liveProductHandle||'';
      let p=handle?await fetchProduct(handle):null;
      if(!p){
        const query=(card.querySelector('h3,h4')||{}).textContent||card.getAttribute('aria-label')||'';
        const resolved=await resolveProduct(query);
        if(resolved){handle=resolved.handle;p=resolved.product;card.dataset.liveProductHandle=handle}
      }
      if(p)applyCard(card,p);
    }
  }
  async function healProductRoots(){
    const roots=[...document.querySelectorAll('[data-live-inventory-root]')];
    for(const el of roots){
      let handle=el.dataset.liveProductHandle||'';
      let p=handle?await fetchProduct(handle):null;
      if(!p){
        const query=(el.querySelector('h1')||{}).textContent||'';
        const resolved=await resolveProduct(query);
        if(resolved){el.dataset.liveProductHandle=resolved.handle}
      }
    }
    if(window.MomoLiveInventory&&window.MomoLiveInventory.refresh)window.MomoLiveInventory.refresh(true);
  }
  function protectForms(){
    document.querySelectorAll('form').forEach(form=>{
      form.setAttribute('autocomplete',form.classList.contains('email-capture')?'on':'off');
      if(form.dataset.momoGuarded)return; form.dataset.momoGuarded='1';
      form.addEventListener('submit',()=>{
        const btn=form.querySelector('button[type="submit"],input[type="submit"]');
        if(!btn)return; btn.setAttribute('aria-busy','true');
        setTimeout(()=>btn.removeAttribute('aria-busy'),5000);
      },{passive:true});
    });
    document.querySelectorAll('a[target="_blank"]').forEach(a=>{
      const rel=new Set((a.getAttribute('rel')||'').split(/\s+/).filter(Boolean));rel.add('noopener');rel.add('noreferrer');a.setAttribute('rel',[...rel].join(' '));
    });
  }
  let refreshTimer=null;
  function refreshSoon(){clearTimeout(refreshTimer);refreshTimer=setTimeout(()=>{healProductRoots();healCards();},250)}
  protectForms(); refreshSoon();
  window.addEventListener('pageshow',refreshSoon);
  window.addEventListener('online',refreshSoon);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)refreshSoon()});
  document.addEventListener('shopify:section:load',()=>{protectForms();refreshSoon()});
  window.MomoStorefrontHardening={refresh:refreshSoon,resolveProduct};
})();

/* Product image galleries: thumbnail navigation on desktop + native horizontal swipe on mobile. */
(function(){
  function setupGallery(root){
    if(!root || root.dataset.galleryReady==='1')return;
    root.dataset.galleryReady='1';
    const track=root.querySelector('[data-gallery-track]');
    const slides=[...root.querySelectorAll('[data-gallery-slide]')];
    const thumbs=[...root.querySelectorAll('[data-gallery-thumb]')];
    const prev=root.querySelector('[data-gallery-prev]');
    const next=root.querySelector('[data-gallery-next]');
    if(!track || !slides.length)return;

    let index=0;
    let raf=0;

    function maxIndex(){return Math.max(0,slides.length-1)}
    function setActive(i,scrollThumb){
      index=Math.max(0,Math.min(maxIndex(),Number(i)||0));
      slides.forEach((slide,n)=>slide.classList.toggle('is-active',n===index));
      thumbs.forEach((thumb,n)=>{
        const active=n===index;
        thumb.classList.toggle('is-active',active);
        thumb.setAttribute('aria-current',active?'true':'false');
        if(active && scrollThumb!==false){
          try{thumb.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'})}catch(e){}
        }
      });
      if(prev)prev.disabled=index===0;
      if(next)next.disabled=index===maxIndex();
    }
    function go(i){
      const target=Math.max(0,Math.min(maxIndex(),Number(i)||0));
      const width=track.clientWidth || 1;
      track.scrollTo({left:target*width,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      setActive(target,true);
    }
    function syncFromScroll(){
      cancelAnimationFrame(raf);
      raf=requestAnimationFrame(()=>{
        const width=track.clientWidth||1;
        const current=Math.round(track.scrollLeft/width);
        if(current!==index)setActive(current,true);
      });
    }

    thumbs.forEach((thumb,n)=>thumb.addEventListener('click',()=>go(n)));
    if(prev)prev.addEventListener('click',()=>go(index-1));
    if(next)next.addEventListener('click',()=>go(index+1));
    track.addEventListener('scroll',syncFromScroll,{passive:true});
    track.addEventListener('keydown',e=>{
      if(e.key==='ArrowLeft'){e.preventDefault();go(index-1)}
      if(e.key==='ArrowRight'){e.preventDefault();go(index+1)}
      if(e.key==='Home'){e.preventDefault();go(0)}
      if(e.key==='End'){e.preventDefault();go(maxIndex())}
    });
    window.addEventListener('resize',()=>{
      const width=track.clientWidth||1;
      track.scrollLeft=index*width;
    },{passive:true});
    setActive(0,false);
  }
  function init(scope){
    (scope||document).querySelectorAll('[data-product-gallery]').forEach(setupGallery);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));
  else init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
